import { Injectable } from '@angular/core';
import { ResourceRestService } from '../../workflow-config/services/resource-rest.service';
import { Observable } from 'rxjs';
import { Resources } from '../../workflow-config/constants/resources.enum';
import { EntityTreeElement } from '../../../../../../ispm-web/shared/modules/common';
import { RevisionContextHttpClient } from '@ispm-client/modules/core/services/revision-context-http-client';


export const ENTITY_TREE_URL: string = 'entity-tree';
@Injectable()
export class EntityTreeService {

  constructor(private _http: RevisionContextHttpClient) {
  }

  public static getRevisionId(): string {
    return ResourceRestService.getResourcesString(Resources.RequestedRevision);
  }

  create(resourceType: string, element: EntityTreeElement): Observable<EntityTreeElement> {
    return this._http.post(`${ENTITY_TREE_URL}/${resourceType}`, element);
  }

  search(resourceType: string, searchParams: { [key: string]: string}): Observable<Array<EntityTreeElement>> {
    return this._http.post(`${ENTITY_TREE_URL}/${resourceType}/search`, searchParams);
  }

  update(resourceType: string, element: EntityTreeElement): Observable<EntityTreeElement> {
    const updateProgressionUrl = `${ENTITY_TREE_URL}/${resourceType}/${element.id}`;
    return this._http.put(updateProgressionUrl, element, null, { Accept: 'application/json'});
  }

  get(resourceType: string, elementId: string): Observable<EntityTreeElement> {
    return this._http.get(`${ENTITY_TREE_URL}/${resourceType}/${elementId}`);
  }

}
